<template>
  <header class="ota-webshop-header">
    <div class="ota-webshop-header-container">
      <div class="red-wurm">
        <OSvg svg="red-wurm" class="md:hidden" />
        <OSvg svg="red-wurm-large" class="hidden md:block" />
      </div>
      <div class="lightning">
        <OSvg svg="header-lightning" class="lg:hidden" />
        <OSvg svg="header-lightning-large" class="hidden lg:block" />
      </div>
      <div class="ota-webshop-header-overlay" />
      <div class="ota-webshop-header-body">
        <p
          v-if="joinedBreadCrumbs"
          class="mb-5 ota-p12 font-bold"
          v-text="joinedBreadCrumbs"
        />
        <h1 class="mb-3 ota-h1" v-text="title" />
        <h2 class="description ota-p14" v-html="description" />
        <span
          v-if="isAuthenticated"
          class="ota-h4 block mt-3 md:mt-6"
          v-html="$t('Loyalty.Webshop.Navbar.YourCredits', { price: `
          <span class='text-orange-300 montserrat-currency font-body pl-1'>
            ${getEuros(amount)}
          </span>` })"
        />
      </div>
    </div>
  </header>
</template>

<script>
import { getEuros } from '@/utils/general'

const OSvg = () => import('@/components/OSvg')

export default {
  name: 'WebshopHeader',
  components: {
    OSvg
  },
  props: {
    breadCrumbs: {
      type: Array,
      default: () => ([])
    },
    title: {
      type: String,
      default: ''
    },
    country: {
      type: String,
      default: 'nl'
    },
    description: {
      type: String,
      default: ''
    },
    amount: {
      type: Number,
      default: 0
    },
    isAuthenticated: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    joinedBreadCrumbs () {
      return this.breadCrumbs.join(' | ').trim()
    }
  },
  methods: {
    getEuros (amount) {
      return getEuros(this.country || 'nl', amount)
    }
  }
}
</script>

<style lang="postcss" scoped>
.ota-webshop-header {
  @apply text-gray-600 mb-7;

  &-container {
    @apply mx-auto relative pt-12 pb-7;
    max-width: 125.4rem;

    .red-wurm {
      @apply absolute z-10 top-0;
    }

    .lightning {
      @apply absolute z-30;
      top: 1rem;
      right: 1rem;
    }
  }

  &-overlay {
    @apply bg-purple-400 absolute left-0 right-0 rounded-b-lg top-0;
    bottom: 20%;
  }

  &-body {
    @apply bg-white rounded-lg shadow-md px-5 py-7 mx-5 relative z-20;

    .description {
      max-width: 45rem;
    }
  }
}

@screen md {
  .ota-webshop-header {
    @apply mb-0;
    min-height: 35.6rem;

    &-container {
      @apply pt-20;

      .lightning {
        top: unset;
        bottom: 0rem;
        right: 1.2rem;
      }
    }

    &-body {
      @apply mx-auto px-24;
      padding-top: 5.7rem;
      padding-bottom: 5.7rem;
      max-width: 110rem;
    }
  }
}
</style>
